export const GET_MESSAGES = 'GET_MESSAGES'
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'
export const MARK_AS_READ = 'MARK_AS_READ'
export const EMAIL_SEARCH_LIMIT = 20